/* eslint-disable @eslint-react/dom/no-missing-button-type */
/* eslint-disable @eslint-react/no-clone-element */
import classNames from 'classnames';
import {
  cloneElement,
  ForwardedRef,
  isValidElement,
  ReactElement,
  ReactNode,
} from 'react';

type SlotProps = {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  dataAttributes?: Record<string, unknown>;
  icons?: {
    leading?: ReactNode;
    trailing?: ReactNode;
  };
  ref?: ForwardedRef<HTMLButtonElement>;
};

export const ButtonSlot = ({
  children,
  className,
  dataAttributes,
  disabled,
  icons,
  ref,
}: SlotProps) => {
  if (!isValidElement(children)) {
    throw new Error('Slot component expects a valid React element as a child.');
  }

  const slotClassNames = classNames(children.props.className, className);
  const InnerChildren = (
    <>
      {icons?.leading && <span>{icons.leading}</span>}
      {children.props.children}
      {icons?.trailing && <span>{icons.trailing}</span>}
    </>
  );

  if (disabled) {
    return (
      <button className={slotClassNames} {...dataAttributes} disabled ref={ref}>
        {InnerChildren}
      </button>
    );
  }

  return cloneElement(children as ReactElement, {
    className: slotClassNames,
    ...dataAttributes,
    children: InnerChildren,
    ref,
  });
};
